<!--
* @author 肖阳
* @time 2020-9-10
* @dec 生成流程绘制 基本节点(审批 抄送)组装逻辑
*  组装
-->
<script>
import AddNodeBtn from "@/CommonDP/components/DrawFlow/src/components/AddNodeBtn";
import RowFactory from "@/CommonDP/components/DrawFlow/src/components/DrawRow/FactoryRow";

import { RowNode, ConditionNode, CopyNode } from "./components/NodeConfigFactory/NodeFactory";
import FlowFactory from "./components/factory";
import { HashCode, transToTreeDat, on, off, rafThrottle } from "./utils";
import FlowNode from "@/CommonDP/components/DrawFlow/src/components/DrawRow/FlowNode";
import EditMode from "@/CommonDP/enums/EditMode";

export default {
  name: "FactoryDrawFlow",
  components: {
    AddNodeBtn,
    FlowNode
  },
  props: {
    flowConfig: {
      type: Array,
      default: () => []
    },
    // @deprecated
    flowType: {
      type: Number,
      default: 0
    },
    editMode: {
      type: Number,
      default: EditMode.CREATE_0
    }
  },
  data() {
    return {
      rectTypeDic: {
        1: "审批节点",
        2: "规则节点",
        3: "抄送人",
        4: "开始节点"
      },
      isColList: ["3", "5"],
      selfConfig: null,
      currentNode: null,
      // 缓存数据
      cacheData: null,
      transform: {
        // 放大缩小使用
        offsetX: 0,
        offsetY: 0,
        scale: 1,
        scaleX: 0,
        scaleY: 0
      },
      maxScale: 1.5,
      minScale: 0.7,
      cursor: ""
    };
  },
  computed: {
    transformStyle() {
      return {
        transform: `scale(${this.transform.scale}) translate(${this.transform.offsetX}px,${this.transform.offsetY}px)`,
        cursor: this.cursor
      };
    }
  },
  watch: {
    FlowConfig: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  created() {
    this.init();
  },
  methods: {
    handleMouseDown(e) {
      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this.cursor = "move";
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + (ev.pageX - startX) / this.transform.scale;
        this.transform.offsetY = offsetY + (ev.pageY - startY) / this.transform.scale;
      });
      on(document, "mousemove", this._dragHandler);
      const moveFn = () => {
        off(document, "mousemove", this._dragHandler);
        this.cursor = "";
      };
      on(document, "mouseup", moveFn);
      this.$on("hook:beforeDestroy", () => {
        off(document, "mouseup", moveFn);
      });
      e.preventDefault();
    },
    mousewheel: rafThrottle(function(e) {
      const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
      // this.transform.scaleX = e.pageX;
      // this.transform.scaleY = e.pageY;
      if (delta > 0) {
        this.transform.scale < this.maxScale ? (this.transform.scale += 0.1) : "";
      } else {
        this.transform.scale > this.minScale ? (this.transform.scale -= 0.1) : "";
      }
    }),
    restore() {
      this.transform = { // 放大缩小使用
        offsetX: 0,
        offsetY: 0,
        scale: 1,
        scaleX: 0,
        scaleY: 0
      };
    },
    // 节点数据变化事件
    nodeChange(node) {
      this.currentNode.title = node.title;
      this.currentNode.content = node.content;
      this.currentNode.nodeKey = node.nodeKey;
      this.currentNode.conditional = node.conditional;// 条件专业字段
      this.currentNode.flowNodeDefinitionPermissionPos = node.flowNodeDefinitionPermissionPos;
      this.selfConfig.forEach(i => {
        if (i.id === this.currentNode.id) {
          i.data = node.data;
          i.flowNodeDefinitionPermissionPos = node.flowNodeDefinitionPermissionPos;
          i.content = node.content;
          i.title = node.title;
          i.conditional = node.conditional;
          i.nodeKey = node.nodeKey;
        }
      });
      this.$forceUpdate();
    },
    /**
     * 添加条件框
     */
    addBranch(node) {
      const newNode = new CopyNode(node[node.length - 2]);
      this.selfConfig.splice(this.selfConfig.length - 1, 0, newNode);
      // this.selfConfig = this.selfConfig.concat([newNode]);
    },
    creatBusNodeChange() {
      // EventBus.$on("nodeChange", this.nodeChange);
    },
    /**
     * 获取传参数据结构
     */
    getResData() {
      let list = JSON.parse(JSON.stringify(this.selfConfig));
      this.transformTree(list);
      list.forEach(i => {
        if (i.row) {
          delete i.childNode;
        }
      });
      list = this.shakeDeleteNode(list);
      return list;
    },
    // 删除没有上级的节点
    shakeDeleteNode(list) {
      const root = JSON.parse(JSON.stringify(list)).filter(i => i.root)[0];
      let selfConfig = JSON.parse(JSON.stringify(list)).filter(i => !i.root);
      const ids = list.map(i => i.id);
      let hasNoPidNode = false;
      // 删除pids没有id的节点
      selfConfig.forEach(i => {
        if (i.pids.some(j => !ids.includes(j))) {
          hasNoPidNode = true;
          selfConfig = this.deleteNode(selfConfig, i);
        }
      });
      if (root) selfConfig.unshift(root);
      if (hasNoPidNode) return this.shakeDeleteNode(selfConfig);
      return selfConfig;
    },
    /**
     * 初始化 数据私有化
     */
    init() {
      this.selfConfig = JSON.parse(JSON.stringify(this.flowConfig));
    },
    /**
     *  @param data  源数组一维数组
     *  @requires  tree 二维数组
     */
    transformTree(data) {
      return transToTreeDat(data);
    },
    clickSelectBox(nextNode) {
      const { node, selfConfig } = this.getNodeFactory(nextNode);
      this.selfConfig = selfConfig.concat(node);
    },
    /**
     * 根据isRow去判断row或者rol
     */
    getNodeFactory(nextNode) {
      if (!nextNode.row) {
        const { node, selfConfig } = this.getColNode(nextNode);
        return { node, selfConfig };
      } else {
        const { node, selfConfig } = this.getRowNode(nextNode);
        return { node, selfConfig };
      }
    },
    /**
     * 获取row节点
     */
    getRowNode(nextNode) {
      const node = [new RowNode(nextNode)];
      const selfConfig = this.repickArr(node[0]);
      return { node, selfConfig };
    },
    /**
     * 获取col节点
     */
    getColNode(nextNode) {
      const groupId = HashCode();
      const node = [new ConditionNode({ groupId, ...nextNode }), new ConditionNode({ groupId, ...nextNode })];
      node[1].conditionRank = 9999;
      node[0].conditionRank = 1;
      node[0].title = "条件分支";
      const repickConfig = {
        groupId: node[1].groupPid,
        id: node[1].id
      };
      const selfConfig = this.repickArr(repickConfig);
      this.locationScroll();
      return { node, selfConfig };
    },
    /**
     * 定位滚动条
     */
    locationScroll() {
      // window.location.hash = ".bottom-right-cover-line";
      const el = document.getElementsByClassName("dingflow-design")[0];
      setTimeout(() => {
        el.scrollLeft = el.scrollWidth - el.clientWidth + 340;
      }, 0);
    },
    /**
     * 重定位数组
     */
    repickArr(repickConfig) {
      const selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
      selfConfig.forEach(i => {
        if (i.row) {
          if (i.groupId === repickConfig.groupId) {
            i.groupId = repickConfig.id;
          }
        } else {
          if (i.groupPid === repickConfig.groupId) {
            i.groupPid = repickConfig.id;
          }
        }
      });
      return selfConfig;
    },
    // 点击节点
    clickNode(nodeConfig) {
      this.currentNode = nodeConfig;
      console.log("nodeConfig", nodeConfig);
      this.$emit("clickNode", nodeConfig);
    },
    // 点击关闭节点
    closeNode(node) {
      const repickConfig = {};
      if (node.row) {
        repickConfig.groupId = node.groupId;
        repickConfig.id = node.id;
        const selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
        this.selfConfig = this.deleteNode(selfConfig, node);
        this.repickDeleteArr(repickConfig);
      } else {
        this.deleteColNode(node);
      }
      this.$emit("closeNode");
    },

    // 删除节点
    deleteNode(selfConfig, node) {
      selfConfig = selfConfig.map(i => i.id !== node.id && i).filter(Boolean);
      return selfConfig;
    },
    // 单独删除col下node
    deleteColNode(node) {
      let selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
      const nodeArr = selfConfig.filter(i => i.groupId === node.groupId && !i.row);
      let deleteArr = [];
      const oldJoin = [];// 默认分支下的节点和分支
      let repickConfig;
      if (nodeArr.length > 2) {
        // 递归删除所有关联子节点
        deleteArr = [node];
        this.deleteLoop(selfConfig, node, deleteArr);
        repickConfig = {
          id: node.id,
          groupId: node.groupId
        };
      } else {
        // 删除整个group(-修改为适配协同宝的逻辑)
        // 删除分支的父级
        const PDom = selfConfig.find(e => e.id === node.groupPid);
        // 删除分支的默认条件分支
        const defaultBranch = selfConfig.filter(e => e.groupId === node.groupId && e.id !== node.id && e.groupPid)[0];
        // 删除分支下合并的第一个节点
        const defaultNode = selfConfig.filter(e => e.groupId === node.groupId && e.id !== node.id && !e.groupPid)[0];

        const allCol = selfConfig.map(i => i.groupId === node.groupId && !i.row && i).filter(Boolean);
        deleteArr = allCol;
        allCol.forEach(i => {
          this.deleteLoop(selfConfig, i, deleteArr);
        });
        defaultNode && deleteArr.push(defaultNode);
        // 处理默认分支下的节点
        this.deleteLoop(selfConfig, defaultBranch, oldJoin);
        oldJoin.forEach(ele => {
          if (ele.groupId === defaultBranch.id) {
            ele.groupId = PDom.id;
          }
        });
        defaultNode && (defaultNode.groupId = oldJoin[oldJoin.length - 1].id);
        defaultNode && oldJoin.push(defaultNode);
        // 处理合并分支下的第一个节点
        repickConfig = {
          id: node.groupId,
          groupId: node.groupPid
        };
      }
      deleteArr.forEach(i => {
        selfConfig = this.deleteNode(selfConfig, i);
      });
      if (oldJoin?.length) {
        selfConfig = [...selfConfig, ...oldJoin];
      }
      this.selfConfig = selfConfig;
      this.repickDeleteArr(repickConfig);
      return selfConfig;
    },
    // 循环遍历删除组下关联节点
    deleteLoop(selfConfig, node, deleteArr) {
      // 获取当前节点下所有关联节点
      const currentDeleteArr = selfConfig.filter(i => {
        if (i.row) {
          return i.groupId === node.id;
        } else {
          return i.groupPid === node.id || i.groupPid === node.groupId;
        }
      });
      if (currentDeleteArr.length) {
        currentDeleteArr.forEach(i => {
          deleteArr.push(i);
          this.deleteLoop(selfConfig, i, deleteArr);
        });
      } else {
        return;
      }
    },
    // 判断是否是row
    judgeNodeIsRow(node) {
      return node.row;
    },
    // 删除后重组数组
    repickDeleteArr(repickConfig) {
      const selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
      selfConfig.forEach(i => {
        if (i.row && i.groupId === repickConfig.id) {
          i.groupId = repickConfig.groupId;
        } else if (!i.row && i.groupPid === repickConfig.id) {
          i.groupPid = repickConfig.groupId;
        }
      });
      this.selfConfig = selfConfig;
    },
    // 绘制body
    drawBody(h, node) {
      if (node.childNode) {
        return FlowFactory.getFactory.bind(this, h, node.childNode)();
      } else {
        return <div></div>;
      }
    }
  },
  render(h) {
    if (!this.selfConfig || this.selfConfig.length === 0) {
      return;
    }
    let flowConfig = JSON.parse(JSON.stringify(this.selfConfig));
    flowConfig = this.transformTree(flowConfig);
    this.cacheData = flowConfig;
    const root = JSON.parse(JSON.stringify(this.selfConfig[0]));
    return (
      <div class='design-engine'>
        <div class='dingflow-design'>
          <div class='ie-polyfill-container'>
            <div class='box-scale' id='box-scale' ref='designView' style={this.transformStyle} onMousedown={this.handleMouseDown} onMousewheel={this.mousewheel}>
              {RowFactory.nodeWrapRender.bind(this, h, root)()}
              {this.drawBody(h, flowConfig[0])}
              <div class='end-node'>
                <div class='end-node-circle'></div>
                <div class='end-node-text'>流程结束</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
</script>

<style scoped lang="less">
.design-engine {
  position: relative;
  height: 100%;
  overflow: auto;
  background-color: #f0f2f5;
  .dingflow-design {
    width: 100%;
    overflow: hidden;
    height: 100%;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    /deep/ .ant-popover-arrow {
      display: none !important;
    }
    .ie-polyfill-container {
      display: -ms-grid;
      -ms-grid-columns: min-content;
      .box-scale {
        transform: scale(1);
        display: inline-block;
        position: relative;
        width: 100%;
        padding: 54.5px 0;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        min-width: -webkit-min-content;
        min-width: -moz-min-content;
        min-width: min-content;
        // background-color: #f5f5f7;
        -webkit-transform-origin: 0 0 0;
        transform-origin: 50% 0px 0px;
        .end-node {
          border-radius: 50%;
          font-size: 14px;
          color: rgba(25, 31, 37, 0.4);
          text-align: left;
          .end-node-circle {
            width: 10px;
            height: 10px;
            margin: auto;
            border-radius: 50%;
            background: #dbdcdc;
          }
          .end-node-text {
            margin-top: 5px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
